module.exports = __webpack_public_path__ + "static/media/semantic.d6658ee9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/semantic.png
// module id = 188
// module chunks = 0